
import * as _ from "lodash"
import {ESRecord} from "../lib/ESRecord";


export class CollectionUtils {


  //sync without redefiniting the source array.
  static sync(tgt: any[], src:any[]): void {

    // Check the inputs
    if  (!(_.isArray(tgt) && _.isArray(src))) {
      return
    }

    tgt.length = 0
    tgt.push.apply(tgt, src)

  }

  static interesect(tgt: any[], intersectsrc:any[], keyFieldName?: string ): void {
    // Check the inputs
    if  (!(_.isArray(tgt) && _.isArray(intersectsrc))) {
      return
    }

    var common
      if(_.isEmpty(keyFieldName))
        common = _.intersection(tgt, intersectsrc)
      else
        common = _.intersectionBy(tgt, intersectsrc,keyFieldName)

    CollectionUtils.sync(tgt, common)
  }

  static addDistinctByKey(tgt: any[], src:any[], keyField: string): void {
    // create dictionary of source keys
    var dct = _.keyBy(tgt, (aRow:any) => { return aRow[keyField] })
    var dctAdded: {[id:number]:any} = {}

    _.forEach(src, (aSrcRow: any) => {
      var key = aSrcRow[keyField]
      if(key in dct) { return }
      if(key in dctAdded) { return }
      dctAdded[key] = true
      tgt.push(aSrcRow)
    })

  }


  static minus(a: any[], b: any[],  keyFieldName: string): any[] {
    if(_.isEmpty(a) || _.isEmpty(b)){
      return a
    }

    let dctToRemove = _.keyBy(b, keyFieldName)

    let returnValue:ESRecord[] = []
    _.forEach(a, (aRow) => {
      if(aRow){
        let idValue = (<any> aRow)[keyFieldName]
        if(!(idValue in dctToRemove)){
          returnValue.push(aRow)
        }
      }
    })

    return returnValue

  }


}